// extracted by mini-css-extract-plugin
export var mainContent = "k_T";
export var mainContentWithGlobal = "k_V";
export var rootPath = "k_S";
export var skeletonMenuContainer = "k_W";
export var skeletonRow = "k_X";